import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as forge from 'node-forge';
import sha256 from 'sha256';
import { NewpasswordmanagementService } from '../../../service/newpasswordmanagement.service';
import { DatasharingService } from '../../../service/datasharing.service';
import { AppconfigService } from '../../../service/appconfig.service';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-change-password-content',
  templateUrl: './change-password-content.component.html',
  styleUrls: ['./change-password-content.component.scss']
})
export class ChangePasswordContentComponent implements OnInit {

  constructor(private router: Router,private psdservice: NewpasswordmanagementService,
    private datasharing: DatasharingService, private configService: AppconfigService,
    private globalService: GlobalService) { }

  ERRSuccMsg=""
  showError:boolean=false
  showSuccess:boolean=false
  showPassword: boolean = true;
  isShowCPwdAnnnew3: boolean = false;
  isShowCPwdAnnconf3: boolean = false;
  newPassword: any;
  confirmPassword: any;
  userInfo: any;
 

  ngOnInit(): void {
    this.datasharing.userProfile.subscribe(data => {
      this.userInfo = data;
     
    })
  }
clearErrSuccMsg(){
  this.ERRSuccMsg=""
  this.showError=false
  this.showSuccess=false
}
resetPasswordset(){
  this.newPassword=null
  this.confirmPassword=null
  this.clearErrSuccMsg()
}
showPasswordE() {
  this.showPassword = !this.showPassword;
}
public credentialencode(cred: any){
  var pki = forge.pki;
  var publicKey = pki.publicKeyFromPem(this.configService.config.publicKey.toString());
  var LDAPencrypted = publicKey.encrypt(cred, 'RSA-OAEP', {
    md: forge.md.sha256.create(),
    mgf1: {
      md: forge.md.sha1.create()
    }
  });
  var encryptdata= forge.util.encode64(LDAPencrypted);
  return encryptdata;
 }
public submitPassword() {
  this.ERRSuccMsg = ""
   if(this.PasswordValidation()){     

    var newPasswordTemp = '';
     if (this.configService.config.instanceType.toLowerCase() == "old") {
       newPasswordTemp = this.credentialencode(this.newPassword)
     }
     else
     {
       newPasswordTemp = sha256(this.newPassword);
     }
    // var passwordDetails = {
      
    //    "temporarypassword": this.newPassword,
    //    "username":this.userInfo?.email,
    //  }
     var passwordDetails = {
      
       "temporarypassword": newPasswordTemp,
     }
     //  this.psdservice.OTPResetPassword(passwordDetails).subscribe(Data => {
          this.psdservice.OtpResetPassword_noUsrNm(passwordDetails).subscribe(Data => {    
         if (Data.status == 'Success') {
          this.showSuccess=true
          this.showError=false
           this.ERRSuccMsg = "Your TCS Cognix™ Client account password has been changed successfully."
           setTimeout(() => {
             this.resetPasswordset();
             this.globalService.logout();
             this.login()
           }, 3000);
         }
       
       else {
         
         if (Data.statusMessage.trim() == 'The password has been used previously. Use a new password') {
           // $("#nopreviouspass").show();

         }
         else {
           // $(".forgoterror").show();
         }
         this.showError=true
         this.showSuccess=false
         this.ERRSuccMsg = Data.statusMessage;
       }
     })
   

  
   }
 }

 public login() {
  this.globalService.login();
}

 public PasswordValidation() {
  var password = this.newPassword != undefined ? this.newPassword : '';
  var passwordlength = password.length;
  var confirmPassword = this.confirmPassword != undefined ? this.confirmPassword : '';
  var confirmPasswordlength = confirmPassword.length;
  var minLength = 8;
  var condititon = true;

  //Regular Expressions.
  var pswdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
  var pswdRegexcfm = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
  var err = 0;
  if ((this.newPassword == undefined || this.newPassword.trim() == "") && (this.confirmPassword == undefined || this.confirmPassword.trim() == "")) {
    // $('#Notentered').hide();
    // $(".newpswderror").show();
    // $(".cfmpswderror").show();
    // $(".privacyerr").show();
  
    this.showError=true
    this.showSuccess=false
    this.ERRSuccMsg = "Please enter new password."
    return false;
  }
  if (this.newPassword == undefined || this.newPassword.trim() == '') {
    // $(".newpswderror").show();
    // $('.mismatcherror').hide();
    // $('.pswdnewlength').hide();
    this.showError=true
    this.showSuccess=false
    this.ERRSuccMsg = "Please enter new password."
    // condititon = false;
    // err++
    return false;
  }
  if ((this.newPassword != undefined || this.newPassword.trim() != '') && (this.confirmPassword == undefined || this.confirmPassword.trim() == '')) {
    // $(".cfmpswderror").show();
    // $('.mismatcherror').hide();
    // $('.pswdcfmlength').hide();

      this.showError=true
      this.showSuccess=false
      this.ERRSuccMsg = "Please enter confirm password."
    // condititon = false;
    // err++
    return false;
  }
  if ((this.newPassword == undefined || this.newPassword.trim() == '') && (this.confirmPassword != undefined || this.confirmPassword.trim() != '')) {
    this.confirmPassword = null;
    // $(".cfmpswderror").show();
    
    this.showError=true
    this.showSuccess=false
    this.ERRSuccMsg = "Please enter new password."

    // condititon = false;
    // err++
    return false;
  }

  if ((password != confirmPassword) && (this.confirmPassword != undefined && this.confirmPassword.trim() != '')) {
    this.showError=true
    this.showSuccess=false
    this.ERRSuccMsg = "Password mismatch."
    // condititon = false;
    // err++
    return false;
  }


  if (passwordlength != 0 && (passwordlength < minLength)) {
 
    this.showError=true
    this.showSuccess=false
    this.ERRSuccMsg = "Please refer to the Password policy."
    // condititon = false;
    err++
    return false;
  }

  if ((confirmPasswordlength < minLength) && (this.confirmPassword != undefined && this.confirmPassword.trim() != '')) {

    this.showError=true
    this.showSuccess=false
    this.ERRSuccMsg = "Password mismatch."
    condititon = false;
    err++
    return false;
  }

  if (passwordlength != 0 && pswdRegex.test(password)) {
    // $(".pswdnewlength").hide();
  
   this.showError=false
   this.showSuccess=false
   this.ERRSuccMsg = ""
  }
  if (passwordlength != 0 && !pswdRegex.test(password)) {
     this.showError=true
     this.showSuccess=false
     this.ERRSuccMsg = "Please refer to the Password policy."
    condititon = false;
    err++
  }
  if (pswdRegexcfm.test(confirmPassword)) {
    this.showError=false
   this.showSuccess=false
   this.ERRSuccMsg = ""
  }
  if (!pswdRegexcfm.test(confirmPassword)) {
    this.showError=true
    this.showSuccess=false
    this.ERRSuccMsg = "Please refer to the Password policy."

    condititon = false;
    err++
    return false;
  }

  if (err > 0) {
    return false;
  }
  else {
    return true;
  }
}
}
